// extracted by mini-css-extract-plugin
export default {"wrapper":"GameBoard_wrapper__IVC3L","waiting":"GameBoard_waiting__kQR3e","waiting_inner":"GameBoard_waiting_inner__0S9qx","hidden":"GameBoard_hidden__gojL2"};